module.exports = __webpack_public_path__ + "img/targets.4d83b1ad.svg";